const l = {
  name: "FoundedFlag",
  dimensions: { width: 39, height: 40 },
  content: `
<svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
	 viewBox="0 0 39.4 39.6" style="enable-background:new 0 0 39.4 39.6;" xml:space="preserve">
<style type="text/css">
	.st0{fill: currentColor;}
</style>
<g>
	<g>
		<path class="st0" d="M24.3,0L5.7,4l0.6,2.9l0,0l5.2,24.3C7.3,32.5,3.3,34.8,0,38.2l1.4,1.4c10.1-10.1,26.5-10.1,36.6,0l1.4-1.4
			c-7-7-16.9-9.5-26-7.4l-1.8-8.6L26.3,19l0.8,3.9l9.8-2.1l-4-18.6l-7.8,1.7L24.3,0z M28.2,18.6L28.2,18.6L25.5,5.9l5.9-1.2
			l3.1,14.7l-5.9,1.2L28.2,18.6z M23.2,4.3L23.2,4.3L25.9,17l-14.7,3.1L8.1,5.5l14.7-3.1L23.2,4.3z"/>
	</g>
</g>
</svg>
  `
};
export {
  l as FoundedFlag
};
